var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"columns is-mobile"},[_c('div',{staticClass:"column"},[_c('p',{staticClass:"subtitle has-text-dark"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_c('div',{staticClass:"column is-narrow"},[_c('a',{staticClass:"has-text-danger",on:{"click":_vm.close}},[_vm._v("Close")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }